import {resetEvents, addEvent, updateEvent, removeEvent} from './EventReducer';
import {fetchEvents, updateEventDetails, fetchDrafts} from './EventThunks';

export const EventActions = {
  fetchEvents,
  addEvent,
  fetchDrafts,
  resetEvents,
  updateEvent,
  removeEvent,
  updateEventDetails,
};
